module.exports = __webpack_public_path__ + "public/SideMenuIcons/ratings.svg?a6155c2d";